import request from '@webtrader/core/request';

import { IAccountBaseResponse } from './index';

export interface IResetPasswordParams {
  email: string;
  metatraderId?: string;
}

const resetPassword = (params: IResetPasswordParams, signal?: AbortSignal) => {
  return request.post<IAccountBaseResponse>('/api/auth/v1/password/reset', params, { signal });
};

export default resetPassword;
